import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { faXmark, faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { NewsItem } from '../../shared/models/NewsItem';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';

export interface IHeaders {
  
  NewsItemID: number;
  Title: string;
  SortOrder: number;
 
}


@Component({
  selector: 'app-news-updates',
  templateUrl: './news-updates.component.html',
  styleUrls: ['./news-updates.component.css']
})
export class NewsUpdatesComponent implements OnInit {
  faXmark = faXmark;
  faPenToSquare = faPenToSquare;
  CurUser: User;
  NewsList: NewsItem[];
  PageIndex: number;
  PageSize: number;
  ItemCount: number;
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  readonly PageSizeOptions: number[] = [5, 10, 20, 50];
  constructor(private http: HttpService, private global: GlobalService, public matDialog: MatDialog, private router: Router) { }

  ngOnInit(): void {
    this.PageSize = 20;
    this.PageIndex = 0;
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
      if (this.CurUser && this.CurUser.IsTolomaticUser) {
        this.LoadNewsItems();
      }
      else {
        this.router.navigate(['/dashboard']);
      }
    });
    
    
  }

  LoadNewsItems() {
    this.http.GetNewsItems(this.PageIndex, this.PageSize).then(x => {
      this.PageIndex = 0;      
      this.ItemCount = x.ItemCount;
      this.NewsList = x.Items;
    });
  }

  AddNewsItem() {
    var newItem = new NewsItem();

    var dialogConfig = this.GetDialogConfig("NewNewsItem");

    var newsItemObject = { type: "NewsItem", object:newItem};
    dialogConfig.data = newsItemObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CloseModal();
    });
    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
      this.SaveNewsItem(event);
      this.CloseModal();
    });
  }

  EditNewsItem(item:NewsItem) {
    

    var dialogConfig = this.GetDialogConfig("NewNewsItem");

    var newsItemObject = { type: "NewsItem", object: item };
    dialogConfig.data = newsItemObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CloseModal();
    });
    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
      this.SaveNewsItem(event);
      this.CloseModal();
    });
  }

  SaveNewsItem(item: NewsItem) {
    this.http.AddNewsItem(item).then(x => {
      if (x.StatusCode == "200") {
        this.LoadNewsItems();
      }
      else {
        //show error message
      }
    });
  }

  DeleteNewsItem(item: NewsItem) {
    this.http.DeleteNewsItem(item.NewsItemID, this.CurUser.UserId.toString()).then(x => {
      this.LoadNewsItems();
    });
  }

  GoToArticle(item: NewsItem) {
    window.open(item.Link, '_blank');
  }

  GetDialogConfig(name: string): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = name;
    dialogConfig.height = "70%";
    dialogConfig.width = "40%";

    return dialogConfig;
  }

  CloseModal() {
    this.CurrentOpenDialog.close();
    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.removeAllListeners();
    this.CurrentOpenDialog = null;
  }


  PageEvent(event: any) {
    this.PageIndex = event.pageIndex;
    this.PageSize = event.pageSize;
    this.LoadNewsItems();
  }

  NewsItemDropped(event: CdkDragDrop<IHeaders[]>) {
    debugger;
    if (event.currentIndex == event.previousIndex)
      return;

    var isMoveAhead = (event.currentIndex - event.previousIndex) < 0;
    
      var currentFile = this.NewsList.filter(x => x.SortOrder == event.previousIndex)[0];
      var catFileList = this.NewsList;


      if (isMoveAhead) {
        for (var i = 0; i < catFileList.length; i++) {
          if (catFileList[i].SortOrder < event.previousIndex && catFileList[i].SortOrder >= event.currentIndex) {
            catFileList[i].SortOrder += 1;
          }
        }
      } else {
        for (var i = 0; i < catFileList.length; i++) {
          if (catFileList[i].SortOrder <= event.currentIndex && catFileList[i].SortOrder > event.previousIndex) {
            catFileList[i].SortOrder -= 1;
          }
        }
    }

      currentFile.SortOrder = event.currentIndex;

      catFileList.sort((a: any, b: any) => {
        if (a.SortOrder < b.SortOrder) {
          return -1;
        } else if (a.SortOrder > b.SortOrder) {
          return 1;
        } else {
          return 0;
        }
      });


      catFileList.forEach(x => {
        this.http.UpdateNewsItemSortOrder(x);
      });
    }
  

}
